export const localStorageVariable = 'referralsCongratulationsRewards';
